import { connect } from 'react-redux';
import DownloadPage from './DownloadPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { downloadProfile } from '../../actions/basicAction';
import { doLogout  } from '../../actions/basicAction';

export const mapStateToProps = (state: AppState) => {
    return {
        btnText: 'Download / Refresh eSim',
        userName: state.user.userDetails!!.userName,
        eSimNumber: state.user.selectedEsimProfiles!!.esimServiceNumber,
        eidNumber: state.basic.eidNumber
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onSubmit: () => {                     
            dispatch(downloadProfile);
        },
        doLogout: () => {
            dispatch(doLogout);
        }
    };
};

const DownloadPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(DownloadPage);

export default DownloadPageContainer;



// WEBPACK FOOTER //
// ./src/components/download/DownloadPageContainer.tsx